const factory = {
    56: "0x437cBaE2b12A701Edcf4dFFB17C23C8C5c20377C",
    97: "0xD3d2cA2fd46A5762DD1Fb4B1585aBBE68137C4Eb"
}

const info = {
    56: "0x60CD2df4FC4ae3D7230D1E4CAC0d9bb7036d9549",
    97: "0x1B557F2695cAA2cb2cEc3B195c443aCD9316cAab"
}

const staking = {
    56: "0x510a427581EFB83FBa0B112B75bC755C67c7209C",
    97: "0x290AB68f845cD4bD5eF18788801556771DB38F67"
}

const blos = {
    56: "",
    97: "0x4774318f88b0d7A12c3cbC0fFB8c86a53956AD83"
}

const usdt = {
    56: "0x55d398326f99059ff775485246999027b3197955",
    97: "0x4774318f88b0d7A12c3cbC0fFB8c86a53956AD83"
}

export default {
    factory,
    info,
    staking,
    blos,
    usdt
}